import { render, staticRenderFns } from "./Links.vue?vue&type=template&id=11105f20&scoped=true"
import script from "./Links.vue?vue&type=script&lang=ts"
export * from "./Links.vue?vue&type=script&lang=ts"
import style0 from "./Links.vue?vue&type=style&index=0&id=11105f20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11105f20",
  null
  
)

export default component.exports